export const PLATFORM_ICON_FILENAMES = [
  "amazon-music.png",
  "anghami.png",
  "apple-music.png",
  "audiomack.png",
  "bandcamp.png",
  "boomplay.png",
  "deezer.png",
  "facebook.png",
  "iheart-radio.png",
  "instagram.png",
  "joox.png",
  "kkbox.png",
  "multiplatform.png",
  "napster.png",
  "netease-cloud-music.png",
  "pandora.png",
  "qobuz.png",
  "soundcloud.png",
  "spotify.png",
  "tiktok.png",
  "tidal.png",
  "twitch.png",
  "twitter.png",
  "yandex-music.png",
  "youtube-music.png",
  "youtube.png",
] as const;

export type PlatformIconFilename = (typeof PLATFORM_ICON_FILENAMES)[number];

export function platformIconUrl({ icon }: { icon: string }): string {
  return `/icons/${icon}`;
}

export function isPlatformIconFilename(
  icon: string
): icon is PlatformIconFilename {
  return (PLATFORM_ICON_FILENAMES as readonly string[]).includes(icon);
}
